import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import Content from "../components/about/Content";

function About() {
  return (
    <div className="">
      <NavBar />
      <Content />
      <Footer />
    </div>
  );
}

export default About;
